var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isTrue)?_c('status',{attrs:{"icon":['fas', 'check-circle'],"color":"green"}}):(_vm.isTrue === false)?_c('status',{attrs:{"icon":['fas', 'times-circle'],"color":"red"}}):_c('status',{attrs:{"icon":['fas', 'question-circle'],"color":"orange"}})
}
var staticRenderFns = []

export { render, staticRenderFns }